import { useState } from 'react';
import type {
  IDropdownMenuInternalProps,
  IPhoneFieldDropdownMenu
} from 'libs/design-system/src/types/Dropdown/dropdown_menu/dropdown-menu';
import { useAutoFocus } from '../../../../hooks/useAutoFocus';
import { PhoneInput } from '../../../PhoneInput';
import { Button } from '../../../Button';
import styles from '../filter-input-field.module.scss';

export const PhoneField = (props: IPhoneFieldDropdownMenu & IDropdownMenuInternalProps) => {

  const { closeDropdown } = (props as IDropdownMenuInternalProps);

  const {
    lang, fieldName, placeholder,
    onChangeHandler, onApplyHandler, onCountryChange,
    country, applyBtnText, errorMsg, closeOnSubmit = true,
    showAllCountries = false
  } = props as IPhoneFieldDropdownMenu;

  const [inputValue, setInputValue] = useState("");
  const [phoneWithoutCode, setPhoneWithoutCode] = useState("");
  const inputRef = useAutoFocus<HTMLInputElement>();

  const handleChange = (phone: string, country?: string, phoneWithoutCountryCode?: string) => {
    onChangeHandler?.(phone, country, phoneWithoutCountryCode);
    setInputValue(phone);
    setPhoneWithoutCode(phoneWithoutCountryCode ?? "");
  };

  const handleApply = () => {
    closeOnSubmit && closeDropdown?.();
    onApplyHandler?.(inputValue);
  };

  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    setTimeout(() => {
      e.target.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }, 300);
  };

  return (
    <div className={styles['filter-field-box']}>
      <PhoneInput
        lang={lang}
        ref={inputRef}
        name={fieldName}
        placeholder={placeholder}
        country={country}
        onChangeHandler={handleChange}
        onCountryChange={onCountryChange}
        onFocus={handleFocus}
        error={errorMsg}
        showAllCountries={showAllCountries}
      />

      <Button
        size='md'
        text={applyBtnText || (lang === 'ar' ? "تطبيق" : "Apply")}
        disabled={!phoneWithoutCode || !!errorMsg}
        onClickHandler={handleApply}
      />
    </div>
  )
}
